import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const healthDistrictsApi = {
    getHealthDistricts: (): Observable<Dtos.GetHealthDistrictsResponse> => {
        //Create the request.
        let request: Dtos.GetHealthDistricts = new Dtos.GetHealthDistricts();

        //Send request.
        const response: Promise<Dtos.GetHealthDistrictsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getHealthDistrictById: (id: number): Observable<Dtos.GetHealthDistrictByIdResponse> => {
        //Create the request.
        let request: Dtos.GetHealthDistrictById = new Dtos.GetHealthDistrictById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetHealthDistrictByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setHealthDistrict: (healthDistrict: Dtos.HealthDistrict): Observable<Dtos.SetHealthDistrictResponse> => {

        let request: Dtos.SetHealthDistrict = new Dtos.SetHealthDistrict();

        request.healthDistrict = healthDistrict;

        // send request
        const response: Promise<Dtos.SetHealthDistrictResponse> = client.post(request);

        return Observable.from(response);

    },
    createHealthDistrict: (): Observable<Dtos.CreateHealthDistrictResponse> => {
        //Create the request.
        let request: Dtos.CreateHealthDistrict = new Dtos.CreateHealthDistrict();

        //Send request.
        const response: Promise<Dtos.CreateHealthDistrictResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateHealthDistrict: (healthDistrict: Dtos.HealthDistrict): Observable<Dtos.ValidateHealthDistrictResponse> => {

        let request: Dtos.ValidateHealthDistrict = new Dtos.ValidateHealthDistrict();

        request.healthDistrict = healthDistrict;

        // send request
        const response: Promise<Dtos.ValidateHealthDistrictResponse> = client.post(request);

        return Observable.from(response);

    },
}